import { useRef } from 'react';

import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import FullScreenModal from '@components/modal/fullscreen-modal';
import PhotoGallery from '@components/photo-gallery/component';
import {
  callWidget,
  isWidgetMaximized,
  restoreCommand
} from '@components/chat-widget/chat-commands';
import { useChatHidden } from '@components/chat-widget/use-chat-hidden';

const PropertyImagesModal = ({
  property,
  modalIsOpen,
  sharingServicesCollection,
  canonicalUrl
}) => {
  const router = useRouter();

  const chatHidden = useChatHidden();

  const galleryInterruptedOpenChat = useRef(false);

  const hideChatWhileGalleryOpen = () => {
    galleryInterruptedOpenChat.current = isWidgetMaximized();
    callWidget('hide');
  };

  const restoreChatOnGalleryClose = () =>
    callWidget(restoreCommand(chatHidden, galleryInterruptedOpenChat.current));

  const onModalClose = () => {
    const currentUrl = router.asPath;
    const urlWithoutQuery = currentUrl.split('?')[0];
    const newQuery = { agentid: router.query.agentid };

    if (router.query.agentid) {
      return router.replace({ pathname: urlWithoutQuery, query: { ...newQuery } }, undefined, {
        shallow: true
      });
    } else {
      return router.replace({ pathname: urlWithoutQuery }, undefined, {
        shallow: true
      });
    }
  };

  return (
    <FullScreenModal
      modalIsOpen={modalIsOpen}
      onModalClose={onModalClose}
      onAfterOpen={hideChatWhileGalleryOpen}
      onAfterClose={restoreChatOnGalleryClose}
      canonicalUrl={canonicalUrl}
      sharingServicesCollection={sharingServicesCollection}
      property={property}
      content={
        <>
          <PhotoGallery triggerFirstSort={modalIsOpen} images={property.images} />
        </>
      }
    />
  );
};

PropertyImagesModal.propTypes = {
  canonicalUrl: PropTypes.string,

  modalIsOpen: PropTypes.bool,

  property: PropTypes.shape({
    address: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        height: PropTypes.number,
        title: PropTypes.string,
        url: PropTypes.string,
        width: PropTypes.number
      })
    ),
    listingUrl: PropTypes.string,
    status: PropTypes.arrayOf(
      PropTypes.shape({
        newConstruction: PropTypes.bool,
        newListing: PropTypes.bool,
        openHouse: PropTypes.bool,
        pending: PropTypes.bool,
        priceChange: PropTypes.bool
      })
    )
  }),

  setModalHasBeenOpened: PropTypes.func,

  sharingServicesCollection: PropTypes.arrayOf(
    PropTypes.shape({
      shareName: PropTypes.string,
      shareUrl: PropTypes.string
    })
  )
};

export default PropertyImagesModal;
